/* Springt bei Variantenwechsel zum passenden Bild in der Produktgalerie,
   ohne die Bildreihenfolge zu veraendern.

   Hintergrund: Die Instant-Sections setzen beim Rendern "initialSlide" auf den
   Index des Variantenbildes. Instant tauscht beim Variantenwechsel aber nur die
   Slides aus und liest die Slider-Parameter nicht neu ein — der Slider bliebe
   also stehen. Dieses Skript holt das nach.

   Liegt bewusst ausserhalb der Instant-generierten Sections, damit es einen
   Instant-Republish uebersteht. Die Variant->Index-Map rendert theme.liquid. */
(function () {
  var el = document.getElementById('pr-variant-slide-map');
  if (!el) return;
  var map;
  try { map = JSON.parse(el.textContent); } catch (e) { return; }

  function variantId() {
    return new URLSearchParams(location.search).get('variant');
  }

  function gallery() {
    var sliders = document.querySelectorAll('.instant-slider:not(.instant-slider-thumbs)');
    for (var i = 0; i < sliders.length; i++) {
      var s = sliders[i];
      if (s.swiper && s.swiper.slides && s.swiper.slides.length > 1 &&
          s.closest('[data-instant-layout="PRODUCT_TEMPLATE"]')) return s.swiper;
    }
    return null;
  }

  var last = variantId();

  // Instant rendert die Section nach dem Klick neu; wie lange das dauert ist
  // nicht zugesichert, daher mehrere Versuche statt einer festen Wartezeit.
  function sync(tries) {
    var id = variantId();
    if (!id || id === last) return;
    var idx = map[id];
    if (idx === undefined) { last = id; return; }
    var sw = gallery();
    if (sw) {
      last = id;
      if (sw.activeIndex !== idx) sw.slideTo(idx);
      return;
    }
    if (tries > 0) setTimeout(function () { sync(tries - 1); }, 200);
  }

  document.addEventListener('change', function () { setTimeout(function () { sync(8); }, 150); }, true);
  window.addEventListener('popstate', function () { setTimeout(function () { sync(8); }, 150); });
})();
